module.exports = __webpack_public_path__ + "static/img/newer-reward-bg.8a33cfe1.png";